import React, { FC } from 'react';
import { CheckboxGroup } from '@trip-ux/components';
import { FieldRenderProps } from 'react-final-form';
import { get } from 'lodash';

export const GenericCheckboxGroup: FC<FieldRenderProps<string[]> & { ariaLabel?: string }> = ({
  labels,
  input,
  meta,
  direction = 'row',
  className = '',
  disabled = false,
  id,
  options,
  newLabel = '',
  onChange,
}) => {
  return (
    <div className={`mb-auto space-between ${className}`}>
      <CheckboxGroup
        {...input}
        direction={direction}
        id={id ? id : input.name}
        onChange={val => {
          input.onChange(val);
          if (typeof onChange === 'function') {
            onChange(val);
          }
        }}
        onBlur={() => input.onBlur()}
        disabled={disabled}
        selectedValues={input.value}
        className="my-auto text-input-policy"
        error={meta.submitFailed && meta.error}
        options={options}
      >
       {newLabel ? get(labels, newLabel, '') : get(labels, input.name, '')}
      </CheckboxGroup>
    </div>
  );
};
GenericCheckboxGroup.displayName = 'GenericCheckboxGroup';
